import { useQuery } from "vue-query"
import { useContext } from "@nuxtjs/composition-api"

import { ApiPaths } from "@/enums"
import { CurrencyFee } from "@/types/models/CurrencyFee"

export default () => {
  const { $axios } = useContext()

  return useQuery(
    "getCurrencyFees",
    async () => {
      const { data } = await $axios.get<CurrencyFee[]>(
        ApiPaths.GET_CURRENCY_FEES,
      )

      return data
    },
    { keepPreviousData: true },
  )
}
